import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { toggleModal } from 'apps/auth/actions/appAction';
import { updateExtraByName } from 'apps/auth/actions/extraAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { PAYMENT_BANK_ACCOUNT, PAYMENT_BANK_CARD } from 'apps/auth/constants/Constants';
import { AUTH_SEND_MAIN_LINK } from 'apps/auth/constants/UrlConstants';
import { UZBEKISTAN } from 'apps/auth/constants/WellKnownCountries';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';

import AddBankAccount from './AddBankAccount';
import AddBankCard from './AddBankCard';
import AddPlumBankCard from './AddPlumBankCard';

const AddCardOrAccountModal = (props) => {
    const isCard = props.addingSourceType === PAYMENT_BANK_CARD;
    const isAccount = props.addingSourceType === PAYMENT_BANK_ACCOUNT;
    const { notNow: notNowMessage } = usePageMessages();
    const { smsConfirmation, notNow: notNowExtra, redirectUrl, cardPan } = useExtra();

    const [canCloseModal, setCanCloseModal] = useState(cardPan ? false : !redirectUrl);
    const [showNotNow, toggleNotNow] = useState(notNowExtra);
    const [showEnterSms, toggleEnterSms] = useState(!!smsConfirmation);

    useEffect(() => {
        if (smsConfirmation) {
            toggleEnterSms(true);
            setCanCloseModal(true);
        } else {
            setCanCloseModal(cardPan ? false : !redirectUrl);
        }
    }, [smsConfirmation]);

    useEffect(() => {
        if (redirectUrl) {
            setCanCloseModal(false);
            toggleNotNow(false);
        }
    }, [redirectUrl]);

    const clickCloseIcon = () => {
        if (!smsConfirmation || (smsConfirmation && !showEnterSms)) {
            props.toggleModal(false);
        } else {
            toggleEnterSms(false);
            if (notNowExtra) {
                setCanCloseModal(false);
                toggleNotNow(true);
            }
        }
    };

    const CardComponent = props.countryId === UZBEKISTAN ? AddPlumBankCard : AddBankCard;

    return (
        <ModalComponent
            rightHeaderComponent={showNotNow && <Button type={'link'} variant="tertiary" size="tight" caption={notNowMessage} href={AUTH_SEND_MAIN_LINK} />}
            canCloseModal={canCloseModal}
            onCloseIconClick={clickCloseIcon}
            isIconClose={!smsConfirmation}
        >
            {isAccount && <AddBankAccount />}
            {isCard && <CardComponent showEnterSms={showEnterSms} toggleEnterSms={toggleEnterSms} />}
        </ModalComponent>
    );
};

const mapStateToProps = (state) => {
    return {
        countryId: state.auth.countryId,
        addingSourceType: state.cards.addingSourceType,
    };
};
export default connect(mapStateToProps, { toggleModal, updateExtraByName })(AddCardOrAccountModal);
